
import { Vue, Component, Prop } from "vue-property-decorator";

import REMOVE_CERTIFICATION from "@/apollo/profile/certifications/RemoveCertification.gql";

import CardItem from "@/components/profile/common/CardItem.vue";
import CardContainer from "@/components/profile/common/CardContainerNew.vue";
import CertificationForm from "@/components/profile/certifications/CertificationForm.vue";

import { User_Certification } from "@/generated/graphql";
import { Moment } from 'moment';
import { NOTIFICATION } from "@/entities/Events";
import Message from '@/data/notificationsMessages';

@Component({
    components: {
        CardItem,
        CardContainer,
        CertificationForm,
    },
})
export default class CertificationCard extends Vue {
    @Prop({ type: Object, required: true }) readonly certification!: User_Certification;
    @Prop({ type: String, required: true }) readonly userId!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;

    isModalOpen: boolean = false;

    get startDate(): string | undefined {
        if (this.certification?.start_date) {
            const startDate = this.$moment(this.certification?.start_date) as unknown as Moment;
            return startDate.format("DD MMM, YYYY")
        }

        return undefined;
    }

    get endDate(): string | undefined {
        if (this.certification?.end_date) {
            const endDate = this.$moment(this.certification?.end_date) as unknown as Moment;
            return endDate.format("DD MMM, YYYY")
        }

        return undefined;
    }


    showModal(): void {
        this.isModalOpen = !this.isModalOpen;
    }

    async removeCertification(): Promise<void> {
        try {
            await this.remove();
            this.$emit('removed');

            this.$eventBus.emit(
                NOTIFICATION,
                Message.successMessage(`${this.certification.institution} is removed from your certification.`)
            );
        } catch (error) {
            var msg = "";
            if (error instanceof Error) {
                msg = error.message;
            } else {
                msg = error as string;
            }
            this.$eventBus.emit(
                NOTIFICATION,
                Message.errorMessage(msg)
            );
        }
    }

    async remove(): Promise<void> {
        await this.$apollo.mutate({
            mutation: REMOVE_CERTIFICATION,
            variables: {
                id: this.certification.id,
            },
        });
    }
}
